import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';
import map from 'lodash/fp/map';
import sumBy from 'lodash/fp/sumBy';
import values from 'lodash/fp/values';
import isEmpty from 'lodash/fp/isEmpty';
import pluck from 'lodash/fp/pluck';
import some from 'lodash/fp/some';
import uniq from 'lodash/fp/uniq';
import orderBy from 'lodash/fp/orderBy';

const selectedAddOnToLineItem = addOn => ({
  sku: addOn.offering.variantSku,
  offeringId: addOn.offering.id,
  price: addOn.product.price,
  quantity: addOn.quantity,
});

const selectedPodToLineItem = pod => ({
  sku: pod.sku,
  offeringId: pod.offeringId,
  price: pod.price,
  quantity: pod.quantity,
});

export const selectCartLineItems = ({ selectedPods, selectedAddOns }) => {
  const podLineItems = flow(
    values,
    map(selectedPodToLineItem)
  )(selectedPods);
  const addOnLineItems = flow(
    values,
    map(selectedAddOnToLineItem)
  )(selectedAddOns);
  return [...podLineItems, ...addOnLineItems];
};

export const selectCartQuantity = ({ selectedPods, selectedAddOns } = {}) => {
  const calcSum = flow(
    values,
    sumBy('quantity')
  );
  return calcSum(selectedPods) + calcSum(selectedAddOns);
};

export const selectEnableEditFlow = state =>
  state.featureFlags['nagini-enable-edit-flow'] === 'on';

export const selectHasSubscription = state => !isEmpty(state.subscription);

// Determine whether or not we're still waiting for data before we can
// make any UI decisions.
export const selectLoadingInitialData = state =>
  some(isEmpty)([
    state.pods,
    state.selectedNicotineStrength,
    state.featureFlags,
  ]);

// Sort the strengths in descending order. We'll use parseFloat here to convert
// all of our string percentages like 5% and 18mg/ml
export const selectNicotineStrengths = state =>
  flow(
    values,
    pluck('nicotine_strength_percent'),
    uniq,
    orderBy(parseFloat, 'desc')
  )(state.pods);

export const selectShowAddOnsPage = state =>
  state.featureFlags['nagini-show-add-ons-page'] === 'on';

export const selectSelectedPodsTotalQuantity = state => {
  return flow(
    get('selectedPods'),
    values,
    sumBy('quantity')
  )(state);
};

export const subtotal = ({ selectedPods }) =>
  Object.values(selectedPods).reduce(
    (subtotal, pod) => subtotal + pod.price * pod.quantity,
    0
  );
